import { Server, Code, Shield, HandHelping } from "lucide-react";
import ScrollAnimation from "../components/animations/ScrollAnimation";
import { useTranslation } from 'react-i18next';
import { useSectionT } from "../contexts/PageVariantContext";

const Services = () => {
  const { t } = useTranslation();
  const sectionT = useSectionT();

  const serviceItems = [
    {
      icon: <Server className="h-8 w-8 text-accent-500" />,
      title: t(sectionT('services.items.0.title')),
      description: t(sectionT('services.items.0.description')),
      features: t(sectionT('services.items.0.features'), { returnObjects: true }) as string[],
    },
    {
      icon: <Code className="h-8 w-8 text-accent-500" />,
      title: t(sectionT('services.items.1.title')),
      description: t(sectionT('services.items.1.description')),
      features: t(sectionT('services.items.1.features'), { returnObjects: true }) as string[],
    },
    {
      icon: <Shield className="h-8 w-8 text-accent-500" />,
      title: t(sectionT('services.items.2.title')),
      description: t(sectionT('services.items.2.description')),
      features: t(sectionT('services.items.2.features'), { returnObjects: true }) as string[],
    },
    {
      icon: <HandHelping className="h-8 w-8 text-accent-500" />,
      title: t(sectionT('services.items.3.title')),
      description: t(sectionT('services.items.3.description')),
      features: t(sectionT('services.items.3.features'), { returnObjects: true }) as string[],
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-poppins font-bold text-primary-900 mb-4">
              {t(sectionT('services.title'))}
            </h2>
            <div className="w-20 h-1 bg-accent-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t(sectionT('services.subtitle'))}
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid md:grid-cols-4 gap-8">
          {serviceItems.map((service, index) => (
            <ScrollAnimation key={index} delay={index * 0.2}>
              <div className="service-card bg-white rounded-xl shadow-md p-8">
                <div className="w-16 h-16 rounded-full bg-accent-500/10 flex items-center justify-center mb-6">
                  {service.icon}
                </div>
                <h3 className="text-xl font-poppins font-semibold text-primary-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-5">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-start">
                      <svg
                        className="h-5 w-5 text-accent-500 mr-2 mt-0.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="inline-block text-accent-500 font-medium hover:text-accent-600 transition-colors"
                >
                  {t(sectionT(`services.items.${index}.button`))} →
                </a>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
